AoPS.Utils.initKeyChain(AoPS, "Alcumus", "Models", "Class");

AoPS.Alcumus.Models.Class = (function () {
	// Dependencies
	var AlcMBase = AoPS.Alcumus.Models.Base;
	var AlcMTrialColl = AoPS.Alcumus.Models.TrialCollection;

	return AlcMBase.BaseModel.extend({
		model_type: "class",
		id_attribute: "class_id",
		defaults: {
			name: "",
			start_date: "",
			current_week: 0,
			total_weeks: 0,
			// Set in constructor to avoid mutability issues
			date_list: null, // {}
			// date_list maps week numbers to calendar dates (strings).
			week_table: null, // {}
			// week_table maps topic IDs to week numbers
		},
		/** Additional attributes:
			user: User model owning this one; guaranteed to be set
			due_topic: Topic model Alcumus recommends the user do next
			topics: collection of Topic models
			trials: collection of Trial models that are loaded for this subject
		*/

		initialize: function () {
			this.set("date_list", {});
			this.set("week_table", {});

			this.set("topics", new AlcMBase.BaseCollection());
			// Ensure we always have the same model as in the user's collection.
			this.get("topics").setCreateFunction(
				_.bind(function (id) {
					var result = this.get("user").get("topics").getOrCreate(id);
					return result;
				}, this)
			);

			// Sort by week, then by Alcumus's topic order
			this.get("topics").comparator = _.bind(function (a, b) {
				var week_table = this.get("week_table");
				var a_week = week_table[a.id];
				var b_week = week_table[b.id];

				if (a_week !== b_week) {
					return a_week < b_week ? -1 : 1;
				} else {
					return a.get("order") < b.get("order") ? -1 : 1;
				}
			}, this);

			this.set("trials", new AlcMTrialColl());
			// Ensure we always have the same model as in the user's collection.
			this.get("trials").setCreateFunction(
				_.bind(function (id) {
					return this.get("user").get("trials").getOrCreate(id);
				}, this)
			);

			this.get("trials").setLoadParams({
				user_id: this.get("user").id,
				class_id: this.id,
			});
			this.get("trials").watchUser(this.get("user"));
		},

		requestLoad: function (callback, context) {
			this.get("user").requestLoad(callback, context);
		},

		getWeekDate: function (week) {
			var week_date = this.get("date_list")[week];
			return week_date ? new moment(week_date).format("MMM D") : "?";
		},

		// returns -1, 0, 1, for past, current, future respectively
		// null if week is not a number.
		getWeekTimeStatus: function (week_num) {
			if (!_.isFinite(week_num)) {
				return null;
			} else if (week_num < this.get("current_week")) {
				return -1;
			} else if (week_num > this.get("current_week")) {
				return 1;
			} else {
				return 0;
			}
		},

		// returns -1, 0, 1, for past, current, future respectively
		// null if topic is not in this class
		getTopicTimeStatus: function (topic_id) {
			return this.getWeekTimeStatus(this.get("week_table")[topic_id]);
		},

		unpack: function (data) {
			if (!data) {
				return;
			}

			// List of topic models whose IDs were found in the schedule
			var topic_list = [];
			if (data.schedule) {
				(function () {
					var week_table = {};
					var date_list = {};

					_.each(
						data.schedule,
						function (row) {
							var new_topic = this.get("topics").getOrCreate(row.topic_id, {
								delay_add: true,
							});
							topic_list.push(new_topic);

							date_list[row.week_num] = row.date;
							week_table[row.topic_id] = row.week_num;
						},
						this
					);

					data.date_list = date_list;
					data.week_table = week_table;
				}).apply(this);
			}

			this.setFields(data);

			// Add the topics in data.schedule
			this.get("topics").add(topic_list, {sort: false});
			// week_table just set, so need to sort the topics again regardless
			this.get("topics").sort();

			this.set("is_self_paced", data.is_self_paced);

			if (data.due_topic_id) {
				this.set("due_topic", this.get("topics").get(data.due_topic_id));
			}
		},
	});
})();
